import React from 'react';
import { useConfirmedMeetings } from '../../../../data/hooks/meeting/useConfirmedMeetings';
import { useMeetingRequests } from '../../../../data/hooks/meeting/useMeetingRequests';
import RelativeRedirect from '../../../elements/RelativeRedirect/RelativeRedirect';
import WaitWhileBusy from '../../../WaitWhileBusy';
import { useSentMeetings } from '../../../../data/hooks/meeting/useSentMeetings';

function EventUserMeetingsDefaultTab(props) {
    const { eventId } = props,
        requests = useMeetingRequests(eventId),
        confirmed = useConfirmedMeetings(eventId),
        sent = useSentMeetings(eventId);

    if (requests.length) return <RelativeRedirect to="/requests" />;
    if (confirmed.length) return <RelativeRedirect to="/confirmed" />;
    if (sent.length) return <RelativeRedirect to="/sent" />;

    return <RelativeRedirect to="/all" />;
}

export default (props) => (
    <WaitWhileBusy>
        <EventUserMeetingsDefaultTab {...props.match.params} />
    </WaitWhileBusy>
);
